import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { CheckCircle } from 'lucide-react';

/**
 * Modal-style card for closing an open trade. Parent owns `closeForm` state.
 */
const CloseTradeForm = ({ entry, closeForm, loading, onChange, onSubmit, onCancel }) => {
  if (!entry) return null;
  const previewPnl =
    closeForm.exitPrice && entry.entryPrice && entry.size
      ? `$${((Number(closeForm.exitPrice) - entry.entryPrice) * entry.size).toFixed(2)}`
      : 'N/A';

  return (
    <Card className="border-2 border-purple-200" data-testid="close-trade-form">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CheckCircle className="text-green-600" size={20} />
          Close Trade: {entry.symbol}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Exit Price *</label>
              <Input
                type="number"
                step="0.01"
                value={closeForm.exitPrice}
                onChange={(e) => onChange({ ...closeForm, exitPrice: e.target.value })}
                placeholder="155.00"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">Entry Price</label>
              <Input value={entry.entryPrice || 'N/A'} disabled className="bg-gray-100" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1">P&L Preview</label>
              <Input value={previewPnl} disabled className="bg-gray-100" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Mistakes Made</label>
            <Textarea
              value={closeForm.mistakes}
              onChange={(e) => onChange({ ...closeForm, mistakes: e.target.value })}
              rows={2}
              placeholder="What went wrong? What would you do differently?"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1">Lessons Learned</label>
            <Textarea
              value={closeForm.lessons}
              onChange={(e) => onChange({ ...closeForm, lessons: e.target.value })}
              rows={2}
              placeholder="What did you learn from this trade?"
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onCancel}>Cancel</Button>
            <Button onClick={onSubmit} disabled={loading} className="bg-green-600 hover:bg-green-700" data-testid="close-trade-submit">
              Close Trade
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CloseTradeForm;
